import React, { Component, Suspense } from 'react';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import AppFrameLayout from '../global/app_frame/app_frame_layout';
import LoadingIndicator from '../global/loading_indicator/loading_indicator';

import appFrameReducer from '../global/app_frame/app_frame_reducer';
import slidesReducer from './slides_reducer';
import usersReducer from '../global/user/user_reducer';
import organizationReducer from '../global/organization/organization_reducer';

const ConverterIndex = React.lazy(() => import('./converter_index/converter_index'));
import SubNav from './sub_nav/sub_nav';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app_frame: appFrameReducer,
    slides: slidesReducer,
    user: usersReducer,
    organziation: organizationReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

class ConverterApp extends Component {

    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppFrameLayout>
                        <SubNav />
                        <Suspense fallback={<LoadingIndicator />}>
                            <ConverterIndex />
                        </Suspense>
                    </AppFrameLayout>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default ConverterApp;
